<template>
    <div class="vc_row wpb_row vc_row-fluid border-top">
        <div class="wpb_column vc_column_container vc_col-sm-10">
            <div class="vc_column-inner ">
                <div class="wpb_wrapper">
                    <nav aria-label="Page navigation example">
                        <ul v-if="data.total>0 && data.last_page>1" class="pagination">
                            <li class="page-item" :class="{disabled: data.current_page==1}">
                                <a @click.prevent="click(data.current_page-1)" class="page-link" href="#" aria-label="Previous">
                                    <span aria-hidden="true">&laquo;</span>
                                    <span class="sr-only">Previous</span>
                                </a>
                            </li>
                            <li v-if="data.current_page > 1" class="page-item"><a @click.prevent="click(1)" class="page-link" href="#">1</a></li>
                            <li v-if="data.current_page > 2" class="page-item disabled"><a class="page-link">...</a></li>
                            <li class="page-item active"><a @click.prevent="click(data.current_page)" class="page-link" href="#">{{ data.current_page }}</a></li>
                            <li v-if="data.current_page < data.last_page-1" class="page-item disabled"><a class="page-link">...</a></li>
                            <li v-if="data.current_page < data.last_page" class="page-item"><a @click.prevent="click(data.last_page)" class="page-link" href="#">{{ data.last_page }}</a></li>
                            <li class="page-item" :class="{disabled: data.current_page==data.last_page}">
                                <a @click.prevent="click(data.current_page+1)" class="page-link" href="#" aria-label="Next">
                                    <span aria-hidden="true">&raquo;</span>
                                    <span class="sr-only">Next</span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
        <div class="wpb_column vc_column_container vc_col-sm-2">
            <div class="vc_column-inner ">
                <div class="wpb_wrapper">
                    <div class="pull-right"><button type="button" class="btn btn-primary" @click="clickVolver">Volver</button></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Paginador",
        props: {
            data: {
                type: Object,
                default: () => {}
            },
        },
        methods: {
            click(page){
                this.$emit('paginador-cambio-pagina', page);
            },
            clickVolver(){
                this.$router.go(-1);
            }
        }
    }
</script>

<style>

</style>